import { EventPage } from '../event'

// Backward-compatible route for saved occasion links.
export const OccasionPage = () => EventPage('occasion')
